export const isHomeInStock = (dealers) => {
  let isInStockAtSurroundingDealer = false;

  dealers.map((dealer) => {
    if (dealer.hasModelInStock) {
      isInStockAtSurroundingDealer = true;
    }
  });
  return isInStockAtSurroundingDealer;
};
